module.exports = __webpack_public_path__ + "media/images/flags/4x3/tgo-1b41a4055db984ba0eaf42ee1a664036.svg";